<script lang="ts" setup>
import { useFloating } from '~/composables/event/use-floating'
import { EVENT } from '~/configs/page-url'

const { isShowFloating, closeFloating } = useFloating()
</script>

<template>
  <div v-if="isShowFloating" class="button-floating">
    <div class="button-close" @click="closeFloating">
      <img src="/assets/images/pages/event/floating-close.webp" alt="close" />
    </div>
    <NuxtLink :to="EVENT.PREMIER_LEAGUE_RANKING">
      <img
        class="button-floating__thumb"
        src="/assets/images/pages/event/floating-icon.webp"
        alt="Floating"
        width="100"
        height="96"
      />
    </NuxtLink>
  </div>
</template>

<style lang="scss">
@import '~/assets/scss/components/common/event/floating.scss';
</style>
